import React, { Component } from "react";
import { Link } from "react-router-dom";
import parse from "html-react-parser";
import { Accordion } from "react-bootstrap";
// import CategoryInverters from "../section-components/category-inverters";
import CategoryEBikeBattery from "../section-components/category-ebike-battery";
import ProductOverview from "./product-overview";

// class EBikeBatteryDetails extends Component {
//   render() {
//     let publicUrl = process.env.PUBLIC_URL + "/";

//     return (
//       <div className="ltn__shop-details-area pb-10">
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-8 col-md-12">
//               <div className="ltn__shop-details-inner ltn__page-details-inner mb-60">
//                 <div className="ltn__blog-meta">
//                   <ul>
//                     <li className="ltn__blog-category">
//                       <Link to="#">Featured</Link>
//                     </li>
//                     <li className="ltn__blog-category">
//                       <Link className="bg-orange" to="#">
//                         Power Your life with Atom Power
//                       </Link>
//                     </li>
//                     {/* <li className="ltn__blog-date">
//                       <i className="far fa-calendar-alt" />
//                       May 19, 2021
//                     </li>
//                     <li>
//                       <Link to="#">
//                         <i className="far fa-comments" />
//                         35 Comments
//                       </Link>
//                     </li> */}
//                   </ul>
//                 </div>
//                 <h1>Solar Battery</h1>
//                 <label>
//                   <span className="ltn__secondary-color">
//                     <i className="flaticon-pin" />
//                   </span>
//                   ATP: Intelligent Power Engineered for Excellence
//                 </label>
//                 <h4 className="title-2">Description</h4>
//                 <p>
//                   ATP Li-ion Motorbike & Sport batteries offers Ultimate
//                   performance & experience with an ultra-light design for faster
//                   acceleration. Low self-discharge ensures reliable starts after
//                   long periods off the road. It’s versatile, with easy
//                   installation and top-tier safety features.
//                 </p>
//                 <h5 className="title-2">Zero Maintenance</h5>
//                 <p>Hassle-free performance with no maintenance required.</p>

//                 <h5 className="title-2">Long Charging Cycles</h5>
//                 <p>
//                   Enjoy extended battery life with advanced technology designed
//                   for endurance.
//                 </p>

//                 <h5 className="title-2">Faster Recharge</h5>
//                 <p>
//                   Get back on the road quickly with ultra-fast charging
//                   capabilities.
//                 </p>

//                 <h5 className="title-2">Over Charge Protection</h5>
//                 <p>Built-in safeguards ensure maximum safety and durability.</p>

//                 <h5 className="title-2">Remote Monitoring</h5>
//                 <p>
//                   Stay in control with real-time battery insights at your
//                   fingertips.
//                 </p>
//                 <div className="specifications">
//                   {/* Technical Specifications */}
//                   <h4 className="title-2">Technical Specifications: 1</h4>
//                   <div
//                     className="property-detail-info-list section-bg-1 clearfix mb-60"
//                     style={{ display: "flex", gap: "20px" }}
//                   >
//                     <ul style={{ flex: "1" }}>
//                       <li>
//                         <label>Nominal Voltage:</label> <span>72V</span>
//                       </li>
//                       <li>
//                         <label>Nominal Current:</label> <span>45AH</span>
//                       </li>
//                       <li>
//                         <label>Working Voltage:</label> <span>54 ~ 83V</span>
//                       </li>
//                       <li>
//                         <label>Type:</label> <span>Lithium Ion</span>
//                       </li>
//                       <li>
//                         <label>Life Cycle:</label> <span>&gt;3000 cycles</span>
//                       </li>
//                       <li>
//                         <label>Energy Density:</label> <span>211 Wh/kg</span>
//                       </li>
//                       <li>
//                         <label>Standard Charging Current:</label>{" "}
//                         <span>10A ~ 20A</span>
//                       </li>
//                       <li>
//                         <label>Peak Charging Current:</label> <span>30A</span>
//                       </li>
//                     </ul>
//                     <ul style={{ flex: "1" }}>
//                       <li>
//                         <label>Standard Discharging Current:</label>{" "}
//                         <span>80A</span>
//                       </li>
//                       <li>
//                         <label>Peak Discharging Current:</label>{" "}
//                         <span>90A</span>
//                       </li>
//                       <li>
//                         <label>Charging Cut-off Voltage:</label>{" "}
//                         <span>83V</span>
//                       </li>
//                       <li>
//                         <label>Discharging Cut-off Voltage:</label>{" "}
//                         <span>54V</span>
//                       </li>
//                       <li>
//                         <label>Charging Temperature:</label>{" "}
//                         <span>-20°C ~ 50°C</span>
//                       </li>
//                       <li>
//                         <label>Discharging Temperature:</label>{" "}
//                         <span>-30°C ~ 50°C</span>
//                       </li>
//                       <li>
//                         <label>Storage Temperature:</label>{" "}
//                         <span>-40°C ~ 40°C</span>
//                       </li>
//                     </ul>
//                   </div>
//                 </div>

//                 <div
//                   className="info-sections"
//                   style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}
//                 >
//                   {/* Benefits Section */}
//                   <div
//                     className="info-card"
//                     style={{
//                       flex: "1 1 45%",
//                       padding: "20px",
//                       border: "1px solid #ddd",
//                       borderRadius: "10px",
//                       background: "#f9f9f9",
//                     }}
//                   >
//                     <h4 className="title-2" style={{ marginBottom: "15px" }}>
//                       Benefits
//                     </h4>
//                     <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
//                       <li>3000+ cycle</li>
//                       <li>Advanced Battery Management System</li>
//                       <li>Fast charging & discharging</li>
//                       <li>Environmentally Friendly</li>
//                       <li>Remote Monitoring</li>
//                       <li>Quiet Operation</li>
//                     </ul>
//                   </div>

//                   {/* Usability Facts Section */}
//                   <div
//                     className="info-card"
//                     style={{
//                       flex: "1 1 45%",
//                       padding: "20px",
//                       border: "1px solid #ddd",
//                       borderRadius: "10px",
//                       background: "#f9f9f9",
//                     }}
//                   >
//                     <h4 className="title-2" style={{ marginBottom: "15px" }}>
//                       Usability Facts
//                     </h4>
//                     <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
//                       <li>Temperature Resistance</li>
//                       <li>Clean Backup Power</li>
//                       <li>High Discharge (DOD)</li>
//                       <li>Zero Maintenance</li>
//                       <li>UN 38.3 Certified</li>
//                     </ul>
//                   </div>
//                 </div>

//                 <h4 className="title-2">App and Web Portal for End Users</h4>

//                 <p>
//                   Intuitive power flow monitoring - Say Goodbye to high energy
//                   bills with Self-Powered Mode
//                 </p>

//                 <p>
//                   Viewing power generation and consumption data through an
//                   application
//                 </p>

//                 <p>
//                   Comprehensive and detailed data to assist you in system fault
//                   analysis
//                 </p>

//                 {/* <div className="property-detail-feature-list clearfix mb-45">
//                   <ul>
//                     <li>
//                       <div className="property-detail-feature-list-item">
//                         <i className="flaticon-double-bed" />
//                         <div>
//                           <h6>Living Room</h6>
//                           <small>20 x 16 sq feet</small>
//                         </div>
//                       </div>
//                     </li>
//                     <li>
//                       <div className="property-detail-feature-list-item">
//                         <i className="flaticon-double-bed" />
//                         <div>
//                           <h6>Garage</h6>
//                           <small>20 x 16 sq feet</small>
//                         </div>
//                       </div>
//                     </li>
//                     <li>
//                       <div className="property-detail-feature-list-item">
//                         <i className="flaticon-double-bed" />
//                         <div>
//                           <h6>Dining Area</h6>
//                           <small>20 x 16 sq feet</small>
//                         </div>
//                       </div>
//                     </li>
//                     <li>
//                       <div className="property-detail-feature-list-item">
//                         <i className="flaticon-double-bed" />
//                         <div>
//                           <h6>Bedroom</h6>
//                           <small>20 x 16 sq feet</small>
//                         </div>
//                       </div>
//                     </li>
//                     <li>
//                       <div className="property-detail-feature-list-item">
//                         <i className="flaticon-double-bed" />
//                         <div>
//                           <h6>Bathroom</h6>
//                           <small>20 x 16 sq feet</small>
//                         </div>
//                       </div>
//                     </li>
//                     <li>
//                       <div className="property-detail-feature-list-item">
//                         <i className="flaticon-double-bed" />
//                         <div>
//                           <h6>Gym Area</h6>
//                           <small>20 x 16 sq feet</small>
//                         </div>
//                       </div>
//                     </li>
//                     <li>
//                       <div className="property-detail-feature-list-item">
//                         <i className="flaticon-double-bed" />
//                         <div>
//                           <h6>Garden</h6>
//                           <small>20 x 16 sq feet</small>
//                         </div>
//                       </div>
//                     </li>
//                     <li>
//                       <div className="property-detail-feature-list-item">
//                         <i className="flaticon-double-bed" />
//                         <div>
//                           <h6>Parking</h6>
//                           <small>20 x 16 sq feet</small>
//                         </div>
//                       </div>
//                     </li>
//                   </ul>
//                 </div> */}
//                 <h4 className="title-2">From Our Gallery</h4>
//                 <div className="ltn__property-details-gallery mb-30">
//                   <div className="row">
//                     <div className="col-md-6">
//                       {/* <a
//                         href={publicUrl + "assets/img/others/14.jpg"}
//                         data-rel="lightcase:myCollection"
//                       > */}
//                       <img
//                         className="mb-30"
//                         src={
//                           publicUrl + "assets/img/others/solar-gallery-1.jpg"
//                         }
//                         alt="Image"
//                       />
//                       {/* </a> */}
//                       {/* <a
//                         href={publicUrl + "assets/img/others/15.jpg"}
//                         data-rel="lightcase:myCollection"
//                       > */}
//                       <img
//                         className="mb-30"
//                         src={
//                           publicUrl + "assets/img/others/solar-gallery-2.jpg"
//                         }
//                         alt="Image"
//                       />
//                       {/* </a> */}
//                     </div>
//                     <div className="col-md-6">
//                       {/* <a
//                         href={publicUrl + "assets/img/others/16.jpg"}
//                         data-rel="lightcase:myCollection"
//                       > */}
//                       <img
//                         className="mb-30"
//                         src={
//                           publicUrl + "assets/img/others/solar-gallery-3.jpg"
//                         }
//                         alt="Image"
//                       />
//                       {/* </a> */}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }
// }

// export default EBikeBatteryDetails;

const EBikeBatteryDetails = ({ ebike }) => {
  let publicUrl = process.env.PUBLIC_URL + "/";
  if (!ebike) {
    return <h2 className="text-center mt-5">Product not found</h2>;
  }

  const handleDownload = (fileName) => {
    const link = document.createElement("a");
    link.href = `/brochures/${fileName}`; // Path to the PDF file in public folder
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleUserManualDownload = (fileName) => {
    const link = document.createElement("a");
    link.href = `/brochures/${fileName}`; // Path to the PDF file in public folder
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <div className="ltn__shop-details-area pb-10">
        <div className="container">
          <ProductOverview overview={ebike?.productOverview} />
          <div className="row">
            <div className="col-lg-8 col-md-12">
              <div className="ltn__shop-details-inner ltn__page-details-inner mb-60">
                {/* <div className="ltn__blog-meta">
                  <ul>
                    <li className="ltn__blog-category">
                      <span>Power your life with Atom Power</span>
                    </li>
                    <li className="ltn__blog-category bg-orange">
                      <span>ATP Series Solar Inverters</span>
                    </li>
                  </ul>
                </div> */}

                <div className="ltn__blog-meta mt-2">
                  <ul>
                    {/* <li>
                      <button
                        onClick={() => handleDownload("inverter-flyer.pdf")} // Replace with actual file name
                        className="btn btn-success d-flex align-items-center"
                        style={{
                          gap: "10px",
                          fontWeight: "light",
                          padding: "10px 15px",
                          backgroundColor: "red",
                          border: "none",
                        }}
                      >
                        Download Brochure
                        <i
                          className="fas fa-download"
                          style={{ color: "white" }}
                        ></i>
                      </button>
                    </li> */}

                    {/* <li>
                      <button
                        onClick={() =>
                          handleUserManualDownload("Inverter-User-Manual.pdf")
                        } 
                        className="btn btn-success d-flex align-items-center"
                        style={{
                          gap: "10px",
                          fontWeight: "light",
                          padding: "10px 15px",
                          backgroundColor: "red",
                          border: "none",
                        }}
                      >
                        Download User Manual
                        <i
                          className="fas fa-download"
                          style={{ color: "white" }}
                        ></i>
                      </button>
                    </li> */}
                  </ul>
                </div>

                <h1>E-Bike Battery : {ebike.name}</h1>
                {/* <label>
                  <span className="ltn__secondary-color">
                    <i className="flaticon-pin" />
                  </span>
                  A Smart Battery Solution for Reliable, Everyday Energy
                  Storage!
                </label> */}
                <h4>Description</h4>
                <p>{ebike.description}</p>

                <h4>Technical Specifications</h4>
                <Accordion defaultActiveKey="0">
                  {Object.entries(ebike.specifications).map(
                    ([category, details], index) => (
                      <Accordion.Item
                        eventKey={index.toString()}
                        key={category}
                      >
                        <Accordion.Header className="fw-bold">
                          {category}
                        </Accordion.Header>
                        <Accordion.Body>
                          <ul className="list-group list-group-flush">
                            {Object.entries(details).map(([key, value]) => (
                              <li
                                key={key}
                                className="list-group-item d-flex justify-content-between"
                              >
                                <span className="fw-bold">{key}:</span>{" "}
                                <span>
    {value === "LiFePO" ? (
      <>
        LiFePO<sub>4</sub>
      </>
    ) : (
      value
    )}
  </span>
                              </li>
                            ))}
                          </ul>
                        </Accordion.Body>
                      </Accordion.Item>
                    )
                  )}
                </Accordion>

                <h4 className="mt-5">From Our Gallery</h4>
                <div className="ltn__property-details-gallery mb-30">
                  <div className="row">
                    {ebike?.gallery?.map((image, index) => (
                      <div className="col-md-4 mt-3" key={index}>
                        <img
                          src={image}
                          alt="Gallery Image"
                          className="img-fluid rounded shadow-sm border p-2"
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-12">
              <aside className="sidebar ltn__shop-sidebar ltn__right-sidebar---">
                {/* Author Widget */}
                {/* <div className="widget ltn__author-widget">
                  <div className="ltn__author-widget-inner text-center">
                    <img
                      src={publicUrl + "assets/img/team/4.jpg"}
                      alt="Image"
                    />
                    <h5>Rosalina D. Willaimson</h5>
                    <small>Traveller/Photographer</small>
                    <div className="product-ratting">
                      <ul>
                        <li>
                          <a href="#">
                            <i className="fas fa-star" />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fas fa-star" />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fas fa-star" />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fas fa-star-half-alt" />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="far fa-star" />
                          </a>
                        </li>
                        <li className="review-total">
                          {" "}
                          <a href="#"> ( 1 Reviews )</a>
                        </li>
                      </ul>
                    </div>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                      Veritatis distinctio, odio, eligendi suscipit
                      reprehenderit atque.
                    </p>
                    <div className="ltn__social-media">
                      <ul>
                        <li>
                          <a href="#" title="Facebook">
                            <i className="fab fa-facebook-f" />
                          </a>
                        </li>
                        <li>
                          <a href="#" title="Twitter">
                            <i className="fab fa-twitter" />
                          </a>
                        </li>
                        <li>
                          <a href="#" title="Linkedin">
                            <i className="fab fa-linkedin" />
                          </a>
                        </li>
                        <li>
                          <a href="#" title="Youtube">
                            <i className="fab fa-youtube" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div> */}
                {/* Search Widget */}
                {/* <div className="widget ltn__search-widget">
                  <h4 className="ltn__widget-title ltn__widget-title-border-2">
                    Search Objects
                  </h4>
                  <form action="#">
                    <input
                      type="text"
                      name="search"
                      placeholder="Search your keyword..."
                    />
                    <button type="submit">
                      <i className="fas fa-search" />
                    </button>
                  </form>
                </div> */}
                {/* Form Widget */}
                {/* <div className="widget ltn__form-widget">
                  <h4 className="ltn__widget-title ltn__widget-title-border-2">
                    Drop Messege For Book
                  </h4>
                  <form action="#">
                    <input
                      type="text"
                      name="yourname"
                      placeholder="Your Name*"
                    />
                    <input
                      type="text"
                      name="youremail"
                      placeholder="Your e-Mail*"
                    />
                    <textarea
                      name="yourmessage"
                      placeholder="Write Message..."
                      defaultValue={""}
                    />
                    <button type="submit" className="btn theme-btn-1">
                      Send Messege
                    </button>
                  </form>
                </div> */}
                {/* Top Rated Product Widget */}
                {/* <div className="widget ltn__top-rated-product-widget go-top">
                  <h4 className="ltn__widget-title ltn__widget-title-border-2">
                    Top Rated Product
                  </h4>
                  <ul>
                    <li>
                      <div className="top-rated-product-item clearfix">
                        <div className="top-rated-product-img">
                          <Link to="/product-details">
                            <img
                              src={publicUrl + "assets/img/product/1.png"}
                              alt="#"
                            />
                          </Link>
                        </div>
                        <div className="top-rated-product-info">
                          <div className="product-ratting">
                            <ul>
                              <li>
                                <a href="#">
                                  <i className="fas fa-star" />
                                </a>
                              </li>
                              <li>
                                <a href="#">
                                  <i className="fas fa-star" />
                                </a>
                              </li>
                              <li>
                                <a href="#">
                                  <i className="fas fa-star" />
                                </a>
                              </li>
                              <li>
                                <a href="#">
                                  <i className="fas fa-star" />
                                </a>
                              </li>
                              <li>
                                <a href="#">
                                  <i className="fas fa-star" />
                                </a>
                              </li>
                            </ul>
                          </div>
                          <h6>
                            <Link to="/shop">Luxury House In Greenville </Link>
                          </h6>
                          <div className="product-price">
                            <span>$30,000.00</span>
                            <del>$35,000.00</del>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="top-rated-product-item clearfix">
                        <div className="top-rated-product-img">
                          <Link to="/product-details">
                            <img
                              src={publicUrl + "assets/img/product/2.png"}
                              alt="#"
                            />
                          </Link>
                        </div>
                        <div className="top-rated-product-info">
                          <div className="product-ratting">
                            <ul>
                              <li>
                                <a href="#">
                                  <i className="fas fa-star" />
                                </a>
                              </li>
                              <li>
                                <a href="#">
                                  <i className="fas fa-star" />
                                </a>
                              </li>
                              <li>
                                <a href="#">
                                  <i className="fas fa-star" />
                                </a>
                              </li>
                              <li>
                                <a href="#">
                                  <i className="fas fa-star" />
                                </a>
                              </li>
                              <li>
                                <a href="#">
                                  <i className="fas fa-star" />
                                </a>
                              </li>
                            </ul>
                          </div>
                          <h6>
                            <Link to="/shop">Apartment with Subunits</Link>
                          </h6>
                          <div className="product-price">
                            <span>$30,000.00</span>
                            <del>$35,000.00</del>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="top-rated-product-item clearfix">
                        <div className="top-rated-product-img">
                          <Link to="/product-details">
                            <img
                              src={publicUrl + "assets/img/product/3.png"}
                              alt="#"
                            />
                          </Link>
                        </div>
                        <div className="top-rated-product-info">
                          <div className="product-ratting">
                            <ul>
                              <li>
                                <a href="#">
                                  <i className="fas fa-star" />
                                </a>
                              </li>
                              <li>
                                <a href="#">
                                  <i className="fas fa-star" />
                                </a>
                              </li>
                              <li>
                                <a href="#">
                                  <i className="fas fa-star" />
                                </a>
                              </li>
                              <li>
                                <a href="#">
                                  <i className="fas fa-star-half-alt" />
                                </a>
                              </li>
                              <li>
                                <a href="#">
                                  <i className="far fa-star" />
                                </a>
                              </li>
                            </ul>
                          </div>
                          <h6>
                            <Link to="/shop">3 Rooms Manhattan</Link>
                          </h6>
                          <div className="product-price">
                            <span>$30,000.00</span>
                            <del>$35,000.00</del>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div> */}
                {/* Menu Widget (Category) */}
                {/* <div className="widget ltn__menu-widget ltn__menu-widget-2--- ltn__menu-widget-2-color-2---">
                  <h4 className="ltn__widget-title ltn__widget-title-border-2">
                    Top Categories
                  </h4>
                  <ul className="go-top">
                    <li>
                      <Link to="/blog-grid">
                        Apartments <span>(26)</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/blog-grid">
                        Picture Stodio <span>(30)</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/blog-grid">
                        Office <span>(71)</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/blog-grid">
                        Luxary Vilas <span>(56)</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/blog-grid">
                        Duplex House <span>(60)</span>
                      </Link>
                    </li>
                  </ul>
                </div> */}
                {/* Popular Product Widget */}
                {/* <div className="widget ltn__popular-product-widget">
                  <h4 className="ltn__widget-title ltn__widget-title-border-2">
                    Mobile Application
                  </h4>
                  <div className="row ltn__popular-product-widget-active slick-arrow-1">
                    <div className="col-12">
                      <div className="ltn__product-item ltn__product-item-4 ltn__product-item-5 text-center---">
                        <div className="product-img go-top">
                          <Link>
                            <img
                              src={
                                publicUrl +
                                "assets/img/product-3/Mobile-App.webp"
                              }
                              alt="#"
                            />
                          </Link>
                        </div>
                        <div className="product-info">
                          <h2 className="product-title">
                            <Link>EcoPulse Mobile</Link>
                          </h2>
                          <p>
                            Effortlessly monitor and manage your solar inverter
                            with our intuitive app. Track energy production,
                            battery health, and optimize usage in real-time—all
                            from your phone. Harness the sun’s power at
                            your fingertips!
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
                {/* Popular Post Widget */}
                {/* <div className="widget ltn__popular-post-widget go-top">
                  <h4 className="ltn__widget-title ltn__widget-title-border-2">
                    Leatest Blogs
                  </h4>
                  <ul>
                    <li>
                      <div className="popular-post-widget-item clearfix">
                        <div className="popular-post-widget-img">
                          <Link to="/blog-details">
                            <img
                              src={publicUrl + "assets/img/team/5.jpg"}
                              alt="#"
                            />
                          </Link>
                        </div>
                        <div className="popular-post-widget-brief">
                          <h6>
                            <Link to="/blog-details">
                              Lorem ipsum dolor sit cing elit, sed do.
                            </Link>
                          </h6>
                          <div className="ltn__blog-meta">
                            <ul>
                              <li className="ltn__blog-date">
                                <a href="#">
                                  <i className="far fa-calendar-alt" />
                                  June 22, 2020
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="popular-post-widget-item clearfix">
                        <div className="popular-post-widget-img">
                          <Link to="/blog-details">
                            <img
                              src={publicUrl + "assets/img/team/6.jpg"}
                              alt="#"
                            />
                          </Link>
                        </div>
                        <div className="popular-post-widget-brief">
                          <h6>
                            <Link to="/blog-details">
                              Lorem ipsum dolor sit cing elit, sed do.
                            </Link>
                          </h6>
                          <div className="ltn__blog-meta">
                            <ul>
                              <li className="ltn__blog-date">
                                <a href="#">
                                  <i className="far fa-calendar-alt" />
                                  June 22, 2020
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="popular-post-widget-item clearfix">
                        <div className="popular-post-widget-img">
                          <Link to="/blog-details">
                            <img
                              src={publicUrl + "assets/img/team/7.jpg"}
                              alt="#"
                            />
                          </Link>
                        </div>
                        <div className="popular-post-widget-brief">
                          <h6>
                            <Link to="/blog-details">
                              Lorem ipsum dolor sit cing elit, sed do.
                            </Link>
                          </h6>
                          <div className="ltn__blog-meta">
                            <ul>
                              <li className="ltn__blog-date">
                                <a href="#">
                                  <i className="far fa-calendar-alt" />
                                  June 22, 2020
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="popular-post-widget-item clearfix">
                        <div className="popular-post-widget-img">
                          <Link to="/blog-details">
                            <img
                              src={publicUrl + "assets/img/team/8.jpg"}
                              alt="#"
                            />
                          </Link>
                        </div>
                        <div className="popular-post-widget-brief">
                          <h6>
                            <Link to="/blog-details">
                              Lorem ipsum dolor sit cing elit, sed do.
                            </Link>
                          </h6>
                          <div className="ltn__blog-meta">
                            <ul>
                              <li className="ltn__blog-date">
                                <a href="#">
                                  <i className="far fa-calendar-alt" />
                                  June 22, 2020
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div> */}
                {/* Social Media Widget */}
                {/* <div className="widget ltn__social-media-widget">
                  <h4 className="ltn__widget-title ltn__widget-title-border-2">
                    Follow us
                  </h4>
                  <div className="ltn__social-media-2">
                    <ul>
                      <li>
                        <a href="#" title="Facebook">
                          <i className="fab fa-facebook-f" />
                        </a>
                      </li>
                      <li>
                        <a href="#" title="Twitter">
                          <i className="fab fa-twitter" />
                        </a>
                      </li>
                      <li>
                        <a href="#" title="Linkedin">
                          <i className="fab fa-linkedin" />
                        </a>
                      </li>
                      <li>
                        <a href="#" title="Instagram">
                          <i className="fab fa-instagram" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div> */}
                {/* Tagcloud Widget */}
                {/* <div className="widget ltn__tagcloud-widget go-top">
                  <h4 className="ltn__widget-title ltn__widget-title-border-2">
                    Popular Tags
                  </h4>
                  <ul>
                    <li>
                      <Link to="/blog-grid">Popular</Link>
                    </li>
                    <li>
                      <Link to="/blog-grid">desgin</Link>
                    </li>
                    <li>
                      <Link to="/blog-grid">ux</Link>
                    </li>
                    <li>
                      <Link to="/blog-grid">usability</Link>
                    </li>
                    <li>
                      <Link to="/blog-grid">develop</Link>
                    </li>
                    <li>
                      <Link to="/blog-grid">icon</Link>
                    </li>
                    <li>
                      <Link to="/blog-grid">Car</Link>
                    </li>
                    <li>
                      <Link to="/blog-grid">Service</Link>
                    </li>
                    <li>
                      <Link to="/blog-grid">Repairs</Link>
                    </li>
                    <li>
                      <Link to="/blog-grid">Auto Parts</Link>
                    </li>
                    <li>
                      <Link to="/blog-grid">Oil</Link>
                    </li>
                    <li>
                      <Link to="/blog-grid">Dealer</Link>
                    </li>
                    <li>
                      <Link to="/blog-grid">Oil Change</Link>
                    </li>
                    <li>
                      <Link to="/blog-grid">Body Color</Link>
                    </li>
                  </ul>
                </div> */}
                {/* Banner Widget */}
                {/* <div className="widget ltn__banner-widget d-none go-top">
                  <Link to="/shop">
                    <img src={publicUrl + "assets/img/banner/2.jpg"} alt="#" />
                  </Link>
                </div> */}
              </aside>
            </div>
          </div>

          <CategoryEBikeBattery />
        </div>
      </div>
    </>
  );
};

export default EBikeBatteryDetails;
